import { useMemo, useCallback, useState } from 'react';
import Swal from 'sweetalert2';
import Api from '../../../../../component/Api';

export function useSubmitAll({ students, selectedStudents, setSelectedStudents }) {
    const { http } = useMemo(() => Api(), []);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submittedImeIds, setSubmittedImeIds] = useState([]);

    const selectableSelectedStudents = selectedStudents.filter(imeId => {
        const student = students.find(s => s.ime_id === imeId);
        if (!student) return false;
        const alreadySubmitted = submittedImeIds.includes(imeId);
        const isDraft = student.entry_status === 'draft';
        return isDraft && !alreadySubmitted;
    });

    const selectableSelectedCount = selectableSelectedStudents.length;

    const handleSubmit = useCallback(async () => {
        const result = await Swal.fire({
            title: 'Submit Marks',
            text: `Are you sure you want to submit ${selectableSelectedCount} student(s)?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#581f37',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Yes, Submit',
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
            preConfirm: async () => {
                try {
                    const payload = {
                        ime_ids: selectableSelectedStudents.map(id => parseInt(id, 10)),
                    };
                    const response = await http.post('/is/submitAll', payload);
                    return response;
                } catch (err) {
                    Swal.showValidationMessage(
                        `Submission failed: ${err?.response?.data?.message || 'Please try again.'}`
                    );
                }
            },
        });

        if (!result.isConfirmed) return;

        setIsSubmitting(true);

        try {
            await Swal.fire({
                title: 'Submitted!',
                html: `
                    <div style="display:flex; flex-direction:column; align-items:center; gap:8px;">
                        <p style="margin:0;">Marks submitted successfully.</p>
                        <p style="margin:0; font-size:0.9em; color:#6c757d;">
                            ${selectableSelectedCount} student(s) processed.
                        </p>
                    </div>
                `,
                icon: 'success',
                confirmButtonColor: '#581f37',
                confirmButtonText: 'Done',
            });

            setSubmittedImeIds(prev => [...new Set([...prev, ...selectableSelectedStudents])]);
            setSelectedStudents(prev => [...new Set([...prev, ...selectableSelectedStudents])]);

        } finally {
            setIsSubmitting(false);
        }
        //eslint-disable-next-line
    }, [http, selectableSelectedStudents, selectableSelectedCount, students, setSelectedStudents]);

    return {
        isSubmitting,
        submittedImeIds,
        selectableSelectedCount,
        selectableSelectedStudents,
        handleSubmit,
    };
}